module.exports = __webpack_public_path__ + "img/gift_bg_popup_2.821e9f2.png";